import instance from '../../api';
import { ILoadedReport, IQueryRequest, IReportStore } from './interface';
import { IDynamicTableParams } from '../../components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from '../../interfaces';

export const getAvailableFields = () => {
  return instance()
    .post('/statusReport/availableColumns', {})
    .then((response) => response.data);
};

export const getReportVisibleColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/statusReport/availableColumns', {})
    .then((response) => response.data);
};

export const getReportVisibleGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/statusReport/availableGroupColumns', {})
    .then((response) => response.data);
};

export const getReport = (data: IQueryRequest) => {
  return instance()
    .post('/statusReport/report', data)
    .then((response) => response.data);
};

export const getReportDynamic = (data: IDynamicTableParams) => {
  return instance()
    .post('/statusReport/report', data)
    .then((response) => response.data);
};

export const getUniversalReportData = (data: IDynamicTableParams, requestUrl: string): Promise<any[]> => {
  return instance()
    .post(requestUrl, data)
    .then((response) => response.data);
};

export const getUniversalReportColumns = (requestUrl: string): Promise<any[]> => {
  return instance()
    .post(requestUrl, {})
    .then((response) => response.data);
};

export const saveReport = (reportStore: IReportStore, name: string, isPublic: boolean, type: string) => {
  return instance()
    .post('/jsonStorage/save', {
      jsonData: JSON.stringify(reportStore),
      jsonStorageName: name,
      jsonStorageType: type,
      public: isPublic,
    })
    .then((response) => response.data);
};

export const updateReport = (report: ILoadedReport) => {
  return instance()
    .post('/jsonStorage/update', {
      jsonData: report.jsonData,
      jsonStorageId: report.jsonStorageId,
      jsonStorageName: report.jsonStorageName,
      jsonStorageType: report.jsonStorageType,
      public: report.public,
    })
    .then((response) => response.data);
};

export const loadReport = (reportId: number): Promise<ILoadedReport> => {
  return instance()
    .post('/jsonStorage/load', {
      jsonStorageId: reportId,
    })
    .then((response) => response.data);
};

export const deleteReport = (reportId: number): Promise<ILoadedReport> => {
  return instance()
    .post('/jsonStorage/delete', {
      jsonStorageId: reportId,
    })
    .then((response) => response.data);
};

export const exportExcel = (data: IQueryRequest) => {
  return instance()
    .post('/statusReport/reportExcel', data, {
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const exportExcelReport = (data: IDynamicTableParams, baseApiUrl: string = '/api', requestUrl: string) => {
  return instance(true, baseApiUrl)
    .post(requestUrl, data, { responseType: 'blob' })
    .then((response) => response.data);
};

export const exportPDFReport = (data: IDynamicTableParams, baseApiUrl: string = '/api', requestUrl: string) => {
  return instance(true, baseApiUrl)
    .post(requestUrl, data, { responseType: 'blob' })
    .then((response) => response.data);
};

export const syncReportSum = () => {
  return instance()
    .post('/sync/syncUndefinedSums', {})
    .then((response) => response.data);
};
